module.exports = __webpack_public_path__ + "static/img/8.5d6d7bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/8.png
// module id = 4Wpg
// module chunks = 0